<template>
  <div class="modal-parent">
    <div
      id="whats-new-modal"
      v-shortkey="['esc']"
      class="modal"
      @shortkey="closeModal"
    >
      <div class="modal_topbar modal_topbar--no-actions">
        <div
          id="title-whats-new-modal"
          class="modal_topbar-title modal_topbar-title--no-actions"
          style="display: inline-flex"
        >
          <span> What's New? </span>
        </div>
        <span
          id="exit-whats-new-modal"
          class="modal_topbar-exit"
          @click="closeModal"
          v-html="closeIcon"
        />
      </div>
      <div>
        <img
          :src="whatsNew"
          class="image"
        />
      </div>
      <div class="feature-container__title pt-1">
        Check out some of the latest features that have been added to your system:
      </div>
      <template v-for="feature in newFeatures">
        <div
          :key="feature.title"
          class="feature-container"
        >
          <div class="feature-container__title">
            {{ feature.title }}
          </div>
          <div class="feature-container__description">
            {{ feature.description }}
          </div>
        </div>
      </template>
      <div class="release-notes-button">
        <button
          id="release-notes-btn"
          class="btn btn--grey"
          @click="gotoReleaseNotes"
        >
          See Full Release Notes
        </button>
      </div>
    </div>
    <div class="modal-overlay" />
  </div>
</template>

<script>
import feather from 'feather-icons'
import whatsNew from '@/assets/whats_new.png'

export default {
  name: 'WhatsNew',
  data() {
    return {
      newFeatures: [
        {
          title: 'Enhanced Security with Two-Credential Authentication',
          description:
            `We've added a new rule for Two-Credential Authentication, giving admins the
            ability to require one of the users to be an administrator before
            granting access to critical safes. This extra layer of role-based
            security ensures that only authorized personnel can access your most
            sensitive assets and is required in some regions.`
        },
        {
          title: 'Flexible Two-Factor Authentication with PIN Fallback',
          description:
            `Originally introduced in 1.6.6, a new PIN Fallback mode has been added for Safe devices,
            allowing users without enrolled fingerprints to authenticate using their PIN as a second factor,
            alongside their Card or UserID. This ensures compliance with 2FA requirements while still
            prioritizing biometrics for users with valid fingerprint templates. PIN Fallback provides an
            alternative for users who may have difficulty with fingerprint authentication.`
        },
        {
          title: 'Smoother User Experience and Better Device Stability',
          description:
            `With this release, users will benefit from a new token refresh feature, keeping them logged
            in while actively using the web client instead of a strict timer. We’ve also introduced
            improvements to reduce device reboots, enhance WiFi stability, and ensure smooth operation
            in challenging network conditions specifically around credential synchronization. `
        },
      ],
      closeIcon: feather.icons.x.toSvg(),
      whatsNew,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    gotoReleaseNotes() {
      const _releaseNotesRoute = this.$router.resolve({name: 'releaseNotes'})
      window.open(_releaseNotesRoute.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");

.release-notes-button {
  text-align: center;
  padding: 1;
}

.image {
  width: 100%;
  height: auto;
  margin: 0;
}

.feature {
  font-family: "Montserrat";
  color: $black;
  &-container {
    padding: 1em 1em 1em 0;
    width: 100;
    &__title {
      font-weight: bold;
    }
    &__description {
      text-align: left;
    }
  }
}
</style>
